export default {
  Info: {
    Title: 'In-home care for every person, every day, and every need',
    Book: 'Need assistance? <a target="_blank" rel="noopener noreferrer" href="https://calendly.com/carequilt/30min">Book a demo.</a>',
  },
  Signup: {
    Welcome: 'Welcome back.',
    Signin: 'Sign In',
    WorkspaceForm: {
      Workspace: 'Workspace name',
      Login: 'Continue',
      HaveAccount: 'Need an account? ',
      GetStarted: 'Get started',
      NoOrg: 'This workspace is not valid',
    },
    UserAuth: {
      Email: 'Email',
      Password: 'Password',
      Login: 'Login',
      LoginWith: 'Sign In With',
      ForgotPassword: {
        Create: 'Forgot password? ',
        GetStarted: 'Click here',
      },
      ResetPassword: {
        Title: 'Create new password',
        Body: 'We\'ll ask for this password whenever you sign-in',
        Password: 'New Password',
        RePassword: 'Re-enter Password',
        Action: 'Save change and sign-in',
      },
    },
    UserforgotPassword: {
      FirstStage: {
        Title: 'Forgot password?',
        Body: 'Enter the email address associated with your account.',
        Email: 'Email',
        Action: 'Continue',
      },
      SecondStage: {
        Title: 'Verification required',
        Body: 'To continue, complete this verification step. We\'ve sent a One Time Password (OTP) to your email. Please enter it below.',
        OTP: 'OTP',
        Action: 'Continue',
      },
      ThirdStage: {
        Title: 'Create new password',
        Body: 'We\'ll ask for this password whenever you sign-in',
        Password: 'New Password',
        RePassword: 'Re-enter Password',
        Action: 'Save change and sign-in',
      },
      GoBack: {
        GoBack: 'Go back',
        LoginScreen: 'to the login screen',
      },
    },
  },
  notAuthorizedException: 'Incorrect username or password.',
  federatedLoginFail: 'Sorry, we failed to sign you in, please try again',
};
